import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { isExpand } from "@/views/Home/useData/useHomePage";
import LeftSideBar from "@/views/Home/components/LeftSideBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LeftSideBarDrawer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    style: {"--el-drawer-padding-primary":"0px"},
    "modal-class": "custom-left-drawer",
    "show-close": false,
    modelValue: _unref(isExpand),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isExpand) ? (isExpand).value = $event : null)),
    direction: 'ltr',
    size: 260,
    "with-header": false
  }, {
    default: _withCtx(() => [
      _createVNode(LeftSideBar)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})